var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "mobile" }, [
      _c(
        "div",
        { staticClass: "d-inline-block" },
        [
          _c("v-select", {
            staticClass: "whiteSelectBg",
            attrs: {
              items: _vm.modeOptions,
              label: "Bestellmodus wählen",
              outlined: "",
              "hide-details": "",
              dense: "",
            },
            model: {
              value: _vm.userOrderMode,
              callback: function ($$v) {
                _vm.userOrderMode = $$v
              },
              expression: "userOrderMode",
            },
          }),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "tablet" }, [
      _c(
        "div",
        {
          staticClass: "lighten-3 rounded d-inline-block",
          staticStyle: { transform: "scale(1.2)" },
        },
        [
          _c(
            "v-btn-toggle",
            {
              staticClass: "d-flex justify-center",
              attrs: { mandatory: false, rounded: "" },
              model: {
                value: _vm.userOrderMode,
                callback: function ($$v) {
                  _vm.userOrderMode = $$v
                },
                expression: "userOrderMode",
              },
            },
            [
              _vm.availableModes.includes("inhouse")
                ? _c(
                    "v-btn",
                    {
                      class: { "active-mode": _vm.userOrderMode === "inhouse" },
                      attrs: { value: "inhouse" },
                    },
                    [_vm._v(" 🍽️ Zum Hier essen ")]
                  )
                : _vm._e(),
              _vm.availableModes.includes("takeAway")
                ? _c(
                    "v-btn",
                    {
                      class: {
                        "active-mode": _vm.userOrderMode === "takeAway",
                      },
                      attrs: { value: "takeAway" },
                    },
                    [_vm._v(" 🥡 Zum Abholen ")]
                  )
                : _vm._e(),
              _vm.availableModes.includes("delivery") &&
              !_vm.$store.getters.isKiosk &&
              !_vm.$store.getters.inhouse
                ? _c(
                    "v-btn",
                    {
                      class: {
                        "active-mode": _vm.userOrderMode === "delivery",
                      },
                      attrs: { value: "delivery" },
                    },
                    [_vm._v(" 🚚 Zum Liefern ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }